export default "__VITE_ASSET__DMtgVRyB__"